class MenuPlaceholder {
  constructor() {
    this.$mainMenu    = $('.main-menu')
    this.$placeholder = $(".nav-placeholder")
  }

  _setPlaceholder() {
    let h = this.$mainMenu.outerHeight();

    this.$placeholder.outerHeight(h);
  }

  init() {
    this.constructor();
    const self = this;

    self._setPlaceholder();

    $(window).on('resize', function() {
       self._setPlaceholder();
    });
  }
}

export default MenuPlaceholder



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/menuPlaceholder.js